module.exports = __webpack_public_path__ + "static/media/okr-disabled-icon.950f99c3.svg";